import { Context } from "urql";
import { Logger } from "@lululemon/ecom-pdp/src/utils/logger";
import { publicConfig } from "@lululemon/ecom-core";

const storeLocatorListQuery = `
  query GetStoreLocatorList {
    storeLocatorList {
      name
      fullAddress
      city
      state
      country
      phone
      address1
      address2
      latitude
      longitude
      abilities
      hours {
        openHour
        name
        closeHour
      }
      id
      specialHours {
        id
        date
        description
        openHour
        closeHour
      }
      storeLocatorAmenities {
        buyOnlinePickupStore
      }
    }
  }
`;

const fetchStores = async (graphqlClient) => {
  try {
    const apiHost = `${publicConfig?.apiHost}`;
    const KIWI_PATH = "/cne/graphql";
    Context.url = `${apiHost}${KIWI_PATH}`;

    const { data, error } = await graphqlClient
      .query(storeLocatorListQuery, {}, Context)
      .toPromise();

    if (error) {
      throw error;
    }

    return data?.storeLocatorList;
  } catch (error) {
    Logger.error(
      `Error fetching storeLocatorList response: ${error?.message || error}`,
      {
        isRedirect: false,
        error,
      }
    );

    throw error;
  }
};

export default fetchStores;
